import { getAxiosInstance } from '../../react/utils/networkUtil';
import {
  Notification_Base,
  NotificationGroup,
  NotificationType,
} from '../models/Notification';
import { PaginationQuery, PaginationResult } from '../models/AppPagination';
import { AppSuccess } from '../models/AppSuccess';
import { Transaction_App } from '../models/Transaction';

// delete
export type Notification_Delete_Response = AppSuccess<Notification_Base>;
export const remote_Notification_delete = async (id: number): Promise<Notification_Delete_Response> => {
  try {
    const response = await getAxiosInstance().delete(`/api/notification-ext/${id}`);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_delete');
    throw e;
  }
};
// end delete

// Send system notification
export type Notification_SendSystem_Request = {
  message: {
    topic: string; // "all_devices";
    notification: {
      title: string; // "Ra mắt phiên bản mới 1.0.2"
      body: string; // "Đại hạ giá bản quyền, mua gói 1 năm chỉ với 1.000.000 VND, kết thúc sau ngày 11/08/2024"
    };
  };
};

export type Notification_SendSystem_Response = AppSuccess<any>;
export const remote_Notification_sendSystemNotification = async (
  request: Notification_SendSystem_Request,
): Promise<Notification_SendSystem_Response> => {
  try {
    const response = await getAxiosInstance().post('/api/notification-ext/send-system-notification', request);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_sendSystemNotification');
    throw e;
  }
};
// end send system notification

// get list
export type Notification_GetList_RequestQuery = PaginationQuery & {
  phone_number?: string;
  type?: string;
  app?: Transaction_App;
};
export type Notification_GetList_Response = PaginationResult<Notification_Base>;

export const remote_Notification_getList = async (
  query: Notification_GetList_RequestQuery,
): Promise<Notification_GetList_Response> => {
  try {
    const response = await getAxiosInstance().get('/api/notification-ext', {
      params: query,
    });
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_getList');
    throw e;
  }
};

// end get list


// get one
/**
 * Get notification by numeric ID
 * @deprecated Use remote_Notification_getOneByDocumentId instead for better performance with documentId
 */
export const remote_Notification_getOne = async (id: number): Promise<Notification_Base> => {
  try {
    const response = await getAxiosInstance().get(`/api/notification-ext/get-one/${id}`);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_getOne');
    throw e;
  }
};

export const remote_Notification_getOneByDocumentId = async (documentId: string): Promise<Notification_Base> => {
  try {
    const response = await getAxiosInstance().get(`/api/notification-ext/document-id/${documentId}`);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_getOneByDocumentId');
    throw e;
  }
};
// end get one

// create
export type Notification_Create_Request = {
  title: string;
  content: string;
  group: NotificationGroup;
  type: NotificationType;
  app?: Transaction_App;
  scheduleSendAt: string; //datetime
  sendSMS: boolean;
  sendEmail: boolean;
  sendAppNotification: boolean;
  jsonData: string;

  recipientUserId?: number;
};
export const remote_Notification_create = async (
  createRequest: Notification_Create_Request,
): Promise<Notification_Create_Response> => {
  try {
    const response = await getAxiosInstance().post('/api/notification-ext', createRequest);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_create');
    throw e;
  }
};
export type Notification_Create_Response = AppSuccess<Notification_Base>;
// end create

// update
export type Notification_Update_Request = {
  title?: string;
  content?: string;
  group?: NotificationGroup;
  type?: NotificationType;
  app?: Transaction_App;
  scheduleSendAt?: string; //datetime
  sendSMS: boolean;
  sendEmail: boolean;
  sendAppNotification: boolean;
  jsonData?: string;
};
export const remote_Notification_update = async (
  id: number,
  updateResponse: Notification_Update_Request,
): Promise<Notification_Update_Response> => {
  try {
    const response = await getAxiosInstance().put(`/api/notification-ext/${id}`, updateResponse);
    // console.log(response);
    return response.data;
  } catch (e) {
    console.log('ERROR: when remote_Notification_update');
    throw e;
  }
};
export type Notification_Update_Response = AppSuccess<Notification_Base>;
// end update

// get page my notification
export type Notification_GetMyNotifications_RequestQuery = PaginationQuery & {
  app?: Transaction_App;
};
export type Notification_GetMyNotifications_Response = PaginationResult<Notification_Base>;

export const remote_getMyNotifications = async (query: Notification_GetMyNotifications_RequestQuery): Promise<any> => {
  return (
    await getAxiosInstance().get('/api/notification-ext/my-notifications', {
      params: query,
    })
  ).data;
};
// end get page my notification

export const NotificationAPIs = {
  remote_getMyNotifications,
  remote_Notification_sendSystemNotification,
  remote_Notification_getList,
  remote_Notification_getOne,
  remote_Notification_getOneByDocumentId,
  remote_Notification_create,
  remote_Notification_update,
  remote_Notification_delete,
};
